<template>
  <div class="login-page">
    <div class="container">
      <div class="login-container">
        <div class="row">
          <div class="col-lg-4 col-md-7 col-sm-9 col-12 lfh">
            <div class="card login-box">
              <div class="card-header">
                <img alt="logo" class="card-img-top" src="/images/logo.png" />
                <h4 class="card-title">
                  {{ $t('register.register') }}
                </h4>
              </div>
              <form @keyup.enter="signup" @submit.prevent="signup">
                <div class="card-body">
                  <div class="form-group">
                    <label for="name">{{ $t('register.name') }}</label>
                    <input
                      id="name"
                      v-model="name"
                      autofocus
                      class="form-control"
                      name="name"
                      :placeholder="$t('placeholder.name')"
                      type="text"
                    />
                  </div>
                  <div class="form-group">
                    <label for="email">{{ $t('register.email') }}</label>
                    <input
                      id="email"
                      v-model="email"
                      class="form-control"
                      name="email"
                      :placeholder="$t('placeholder.email')"
                      type="email"
                    />
                  </div>
                  <div class="form-group">
                    <label for="name">{{ $t('register.username') }}</label>
                    <input
                      id="username"
                      v-model="username"
                      autofocus
                      class="form-control"
                      name="username"
                      :placeholder="$t('placeholder.username')"
                      type="text"
                    />
                  </div>
                  <div class="form-group">
                    <label for="password">{{ $t('register.password') }}</label>
                    <input
                      id="password"
                      v-model="password"
                      class="form-control"
                      name="password"
                      :placeholder="$t('placeholder.password')"
                      type="password"
                    />
                  </div>
                  <div class="form-group">
                    <label for="password-confirm">{{
                      $t('register.comfirmPassword')
                    }}</label>
                    <input
                      id="password-confirm"
                      v-model="comfirmpassword"
                      class="form-control"
                      name="password_confirmation"
                      :placeholder="$t('placeholder.comfirmPassword')"
                      type="password"
                    />
                  </div>
                </div>
                <div class="card-action">
                  <button class="btn btn-outline-primary" @click="gotoLogin">
                    <span>{{ $t('register.login') }} </span>
                  </button>
                  <div style="flex: 1 1 auto"></div>
                  <button
                    class="btn btn-primary"
                    :disabled="loading"
                    @click="signup"
                  >
                    <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                    <span>{{ $t('register.register') }}</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data: () => ({
    name: '',
    email: '',
    password: '',
    comfirmpassword: '',
    loading: false,
    username: '',
  }),
  methods: {
    gotoLogin(e) {
      e.preventDefault()
      e.stopPropagation()
      window.location.href = '/login'
    },
    signup(e) {
      e.preventDefault()
      e.stopPropagation()
      this.loading = true
      axios
        .post('/register', {
          name: this.name,
          email: this.email,
          username: this.username,
          password: this.password,
          password_confirmation: this.comfirmpassword,
        })
        .then(
          (res) => {
            //window.location.href = "/";
          },
          (e) => {
            this.loading = false
          }
        )
    },
  },
}
</script>
